import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { typeList, addContract, editContract } from './../request';
import { uploadFile } from './../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { checkEmail, isPhone, getBase64 } from '@/utils/validate';
export default {
  props: ['id', 'infoObj', 'type'],
  components: {
    topTitle
  },
  data() {
    return {
      loading: false,
      partyAPhone: 'validating',
      partyAEmail: 'validating',
      partyBPhone: 'validating',
      partyBEmail: 'validating',
      partyCPhone: 'validating',
      partyCEmail: 'validating',
      partyDPhone: 'validating',
      partyDEmail: 'validating',
      disabled: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      action: uploadFile,
      typeList: typeList,
      form: {},
      partyAForm: {
        name: '',
        legal: '',
        principal: '',
        mobile: '',
        email: '',
        address: ''
      },
      partyBForm: {
        name: '',
        legal: '',
        principal: '',
        mobile: '',
        email: '',
        address: ''
      },
      partyCForm: {
        name: '',
        legal: '',
        principal: '',
        mobile: '',
        email: '',
        address: ''
      },
      partyDForm: {
        name: '',
        legal: '',
        principal: '',
        mobile: '',
        email: '',
        address: ''
      },
      startTime: []
    };
  },
  created() {
    setTimeout(() => {
      this.disabled = this.type == 1 ? true : false;
      if (this.infoObj.contractId) {
        // let arr=JSON.parse(this.infoObj.appendix)
        this.fileList = this.infoObj.appendixList.map((item, index) => {
          let obj = {
            url: item.url,
            uid: index + 1,
            name: item.urlName,
            status: 'done',
            type: item.urlType
          };
          return obj;
        });
        this.form = this.infoObj;
        this.startTime = [this.infoObj.startAt, this.infoObj.endAt];
        this.partyAForm = this.infoObj.partyA || {
          name: '',
          legal: '',
          principal: '',
          mobile: '',
          email: '',
          address: ''
        };
        this.partyBForm = this.infoObj.partyB || {
          name: '',
          legal: '',
          principal: '',
          mobile: '',
          email: '',
          address: ''
        };
        this.partyCForm = this.infoObj.partyC || {
          name: '',
          legal: '',
          principal: '',
          mobile: '',
          email: '',
          address: ''
        };
        this.partyDForm = this.infoObj.partyD || {
          name: '',
          legal: '',
          principal: '',
          mobile: '',
          email: '',
          address: ''
        };
      }
    }, 400);
  },
  computed: {
    rules() {
      return {
        customerId: [{
          required: true,
          message: this.$t('请选择') + this.$t('发布客户'),
          trigger: 'change'
        }],
        partner: [{
          required: true,
          message: this.$t('请填写') + this.$t('合作方'),
          trigger: 'blur'
        }],
        contractType: [{
          required: true,
          message: this.$t('请选择') + this.$t('签约类型'),
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('合同类型'),
          trigger: 'change'
        }],
        contractAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        startTime: [{
          required: true,
          trigger: 'change',
          validator: this.validateTime
        }],
        appendix: [{
          required: true,
          type: 'array',
          validator: this.validateImg,
          trigger: 'change'
        }]
      };
    },
    partyARules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }]
      };
    },
    partyBRules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }]
      };
    },
    partyCRules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }]
      };
    },
    partyDRules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    validateImg(rule, value, callback) {
      console.log(this);
      if (this.fileList.length == 0) {
        callback(new Error(this.$t('请上传') + this.$t('合同附件')));
      } else {
        callback();
      }
    },
    validateTime(rule, value, callback) {
      if (this.startTime.length == 0) {
        callback(new Error(this.$t('请选择') + this.$t('有效期')));
      } else {
        callback();
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    nextFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          console.log(this.form, this.startTime);
          this.form.startAt = this.startTime[0];
          this.form.endAt = this.startTime[1];
          // if(this.form.contractType==1){}
          this.partyAFun();
        }
      });
    },
    partyAFun() {
      this.$refs.partyAForm.validate(valid => {
        if (valid) {
          this.form.partyA = JSON.stringify(this.partyAForm);
          let phone = true,
            email = true;
          if (this.partyAForm.mobile) {
            if (!isPhone(this.partyAForm.mobile)) {
              phone = false;
              this.partyAPhone = 'error';
            } else {
              this.partyAPhone = 'validating';
              phone = true;
            }
          }
          if (this.partyAForm.email) {
            if (!checkEmail(this.partyAForm.email)) {
              email = false;
              this.partyAEmail = 'error';
            } else {
              this.partyAEmail = 'validating';
              email = true;
            }
          }
          if (phone && email) {
            this.partyBFun();
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    partyBFun() {
      this.$refs.partyBForm.validate(valid => {
        if (valid) {
          this.form.partyB = JSON.stringify(this.partyBForm);
          let phone = true,
            email = true;
          if (this.partyBForm.mobile) {
            if (!isPhone(this.partyBForm.mobile)) {
              phone = false;
              this.partyBPhone = 'error';
            } else {
              this.partyBPhone = 'validating';
              phone = true;
            }
          }
          if (this.partyBForm.email) {
            if (!checkEmail(this.partyBForm.email)) {
              email = false;
              this.partyBEmail = 'error';
            } else {
              this.partyBEmail = 'validating';
              email = true;
            }
          }
          if (phone && email) {
            if (this.form.contractType != 1) {
              this.partyCFun();
            } else {
              this.onSubmit();
            }
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    partyCFun() {
      this.$refs.partyCForm.validate(valid => {
        if (valid) {
          this.form.partyC = JSON.stringify(this.partyCForm);
          let phone = true,
            email = true;
          if (this.partyCForm.mobile) {
            if (!isPhone(this.partyCForm.mobile)) {
              phone = false;
              this.partyCPhone = 'error';
            } else {
              this.partyCPhone = 'validating';
              phone = true;
            }
          }
          if (this.partyCForm.email) {
            if (!checkEmail(this.partyCForm.email)) {
              email = false;
              this.partyCEmail = 'error';
            } else {
              this.partyCEmail = 'validating';
              email = true;
            }
          }
          if (phone && email) {
            if (this.form.contractType == 3) {
              this.partyDFun();
            } else {
              this.onSubmit();
            }
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    partyDFun() {
      this.$refs.partyDForm.validate(valid => {
        if (valid) {
          this.form.partyD = JSON.stringify(this.partyDForm);
          let phone = true,
            email = true;
          if (this.partyDForm.mobile) {
            if (!isPhone(this.partyDForm.mobile)) {
              phone = false;
              this.partyDPhone = 'error';
            } else {
              this.partyDPhone = 'validating';
              phone = true;
            }
          }
          if (this.partyDForm.email) {
            if (!checkEmail(this.partyDForm.email)) {
              email = false;
              this.partyDEmail = 'error';
            } else {
              this.partyDEmail = 'validating';
              email = true;
            }
          }
          if (phone && email) {
            this.onSubmit();
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    onSubmit() {
      this.form.appendix = [];
      this.fileList.map(item => {
        if (item.status == 'done' && item.response && item.response.code == 200) {
          if (process.env.NODE_ENV === 'production') {
            this.form.appendix.push(cryptoDecrypt(item.response.data).fileTempUrl);
          } else {
            this.form.appendix.push(item.response.data.fileTempUrl);
          }
        } else {
          console.log(item.url, 444);
          this.form.appendix.push(item.url);
        }
      });
      const fun = this.id != -1 ? editContract : addContract;
      fun(this.form).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message.success(this.$t('操作成功') + '!');
          if (process.env.NODE_ENV === 'production') {
            this.$emit('next', res);
          } else {
            this.$emit('next', res.data);
          }
        } else {
          this.$message.error(this.$t(res.message));
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      console.log(file, 55);
      if (file.type == 'application/pdf' || file.type == 'pdf') {
        // console.log(file.preview);
        // if(file.response){
        // if(process.env.NODE_ENV === 'production'){
        // window.open(cryptoDecrypt(file.response.data).fileTempUrl);
        // }else{
        // window.open(file.response.data.fileTempUrl);
        // }
        // }else{
        window.open(file.url);
        // }
        //
      } else {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
      }
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    }
  }
};